import React from 'react';
import { useLocation } from 'react-router-dom';

import SubHeader from 'src/components/subheader';
import Header from 'src/dispensary-admin/header';
import { isLinkActive } from 'src/models/section-links';
import type { SectionLink } from 'src/models/section-links';
import { getAdminAssetUrl } from 'src/utils/admin-asset-url';

type Props = {
  links: SectionLink[];
};

export function MainHeader(props: Props): JSX.Element | null {
  const { links } = props;
  const location = useLocation();

  const { pathname } = location;
  const activeLink = links.find((link) => isLinkActive(pathname, link.to));
  const headerLabel = activeLink?.headerLabel ?? activeLink?.label;

  if (!activeLink) {
    return null;
  }

  return (
    <>
      <Header.Wrapper links={links}>
        {activeLink.backlink && <Header.BackLink to={`${activeLink.backlink}`}>{headerLabel}</Header.BackLink>}
        {!activeLink.backlink && activeLink.icon && (
          <Header.Title iconSrc={getAdminAssetUrl(`/icons/${activeLink.icon}-big.svg`)}>{headerLabel}</Header.Title>
        )}
        {activeLink.headerComponent && <activeLink.headerComponent />}
      </Header.Wrapper>
      <SubHeader links={links} />
    </>
  );
}
